import React, { useState } from 'react';
import useSWR from 'swr';
import { jsonFetcherWithHandler as fetcher } from 'lib/swr';

import AddComment from './AddComment';
import CommentList from './CommentList';

import { CommunityShotItem } from 'types/community';
import { CommentItem } from 'types/comment';
import { commentsHandler } from 'lib/comments';
import styles from './CommentSection.module.css';

type Props = {
  shotItem: CommunityShotItem;
};

function getLocationHashId() {
  if (typeof window !== 'undefined') {
    // Get the hash from the url
    return window.location.hash;
  }
}
function getTargetCommentId() {
  const hashId = getLocationHashId();
  if (hashId) {
    const match = hashId.match(/#comment(\d+)/);
    if (match) {
      return parseInt(match[1]);
    }
  }
}

const CommentSection = (
  { shotItem }: Props,
  ref: React.Ref<HTMLDivElement>
) => {
  const [scrolled, setScrolled] = useState(false);
  const { data: commentItems } = useSWR<CommentItem[]>(
    `/api/community-posts/${shotItem.communityPostId}/comments`,
    fetcher(commentsHandler)
  );

  if (commentItems && commentItems.length && !scrolled) {
    // lets just finish the layout of our children first and then do a bit of scrolling if we need to.
    setTimeout(() => {
      setScrolled(true);
      const hashId = getLocationHashId();

      if (hashId) {
        // Use the hash to find the first element with that id
        const element = document.querySelector(hashId);

        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest',
          });
        }
      }
    });
  }

  return (
    <div ref={ref} id="commentSection" className={styles.CommentSection}>
      <AddComment shotItem={shotItem} />
      {commentItems && commentItems.length > 0 && (
        <CommentList
          shotItem={shotItem}
          commentItems={commentItems || []}
          targetCommentId={getTargetCommentId()}
        />
      )}
    </div>
  );
};

export default React.forwardRef<HTMLDivElement, Props>(CommentSection);
